module.exports = __webpack_public_path__ + "static/media/icomoon.8c6a9bd4.ttf";